import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=e680ffa8&lang=html"
import script from "./wangeditor.vue?vue&type=script&lang=js"
export * from "./wangeditor.vue?vue&type=script&lang=js"
import style0 from "./wangeditor.vue?vue&type=style&index=0&id=e680ffa8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports